/**
 * 环境
 */
import { getApp } from '@mx/util/get-app';
import { getSystem } from '@mx/util/get-system';
import { getAllCookie } from '@mx/util/get-all-cookie';
import { getAllQueryString } from '@mx/util/get-all-query-string';
import { getUA } from '@mx/util/get-ua';

export enum Runtime {
  Prod,
  Staging,
  Test,
  Dev,
  Local
}

class Env {
  system: string;
  isIOS: boolean;
  isAndroid: boolean;

  appName: string;
  isInConch: boolean;
  isInWaimai: boolean;
  isInMeituan: boolean;
  isInDianping: boolean;
  isTitans: boolean;

  runtime: Runtime;
  bizId: string;
  needHandIdPhoto: string;
  customId: string;
  mwalletToken: string;
  payMemberId: string;
  iph: string;
  utmSource: string;

  // 日志数据
  userid: string;

  // common params
  entry: string;
  commonParams: {
    entry: string;
    token: string;
    uuid: string;
    app: string;
    appVersion: string;
    ci: string;
    nb_appversion: string;
    nb_platform: string;
    certify_session_id?: string;
  };

  constructor() {
    const cookies = getAllCookie();
    const urlParams = getAllQueryString();

    const getParam = (...names: string[]) => {
      for (let i = 0, len = names.length; i < len; i++) {
        const name = names[i];
        const param = cookies[name] || urlParams[name];
        if (param) {
          return param;
        }
      }
      return '';
    };

    if (/\.dev\.sankuai\.com/.test(location.host)) {
      this.runtime = Runtime.Dev;
    } else if (/\.test\.sankuai\.com/.test(location.host)) {
      this.runtime = Runtime.Test;
    } else if (/\.st\.(sankuai|meituan)\.com/.test(location.host)) {
      this.runtime = Runtime.Staging;
    } else if (/\.meituan\.com/.test(location.host)) {
      this.runtime = Runtime.Prod;
    } else {
      this.runtime = Runtime.Local;
    }

    // url params
    this.entry = urlParams.entry;
    this.bizId = urlParams.bizId;
    this.needHandIdPhoto = urlParams.needHandIdPhoto;
    this.customId = urlParams.customId;
    this.mwalletToken = urlParams.mwalletToken || '';
    this.payMemberId = urlParams.payMemberId || '';
    this.userid = getParam('u', 'userid', 'userId');
    this.iph = urlParams.iph || '';
    this.utmSource = urlParams.utm_source;

    // app
    this.system = getSystem();
    this.isIOS = this.system === 'ios';
    this.isAndroid = this.system === 'android';

    this.appName = getApp(urlParams.utm_campaign);
    this.isInConch = this.appName === 'conch'; // 美团支付
    this.isInWaimai = this.appName === 'waimai';
    this.isInMeituan = this.appName === 'group';
    this.isInDianping = this.appName === 'dianping-nova';

    this.isTitans = /titans/.test(navigator.userAgent.toLowerCase());

    this.commonParams = {
      entry: this.entry,
      token: getParam('token'),
      ci: getParam('ci'),
      uuid: getParam('iuuid', 'uuid', 'dpid'),
      app: this.appName,
      appVersion: getParam('version_name', 'wm_appversion') || getUA().appVersion,
      nb_appversion: getParam('version_name', 'wm_appversion') || getUA().appVersion, // 接口需要字段
      nb_platform: urlParams.utm_medium || (this.isIOS ? 'iphone' : 'android') // 接口需要字段
    };
  }
}

export const env = new Env();
